export default "__VITE_ASSET__C1WY0pyR__"